import styled from "styled-components";
import { palette } from "styled-theme";

const DropzoneWrapper = styled.div`
  width: 100%;
  .outer {
    height: 222px;
    border: dashed 1px #bebcbc;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .title {
      height: 38px;
      font-family: Roboto;
      font-size: 30px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.27;
      letter-spacing: normal;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 17px;
      margin-bottom: 0;
    }
    .subtitle {
      margin: 0;

      height: 24px;
      font-family: Roboto;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: rgba(0, 0, 0, 0.65);
    }
    .limit {
      margin-top: 8px;
      margin-bottom: 0;
      height: 22px;
      font-family: Roboto;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.83;
      letter-spacing: 0.43px;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .filesContainer {
    ul {
      padding: 0;
      li {
        display: flex;
        align-items: center;
        max-width: 400px;
        justify-content: space-between;
        list-style: none;
        padding: 0;
        .fileDetails {
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            color: ${palette("primary", 0)};
          }
          .ant-typography {
            padding-right: 10px;
          }
          .ant-typography-edit-content {
            padding-right: 20px;
            display: flex;
            margin: 0;
            align-items: center;
            justify-content: center;
          }
        }
        .deleteContainer {
          cursor: pointer;
          svg {
            color: red;
          }
        }
      }
    }
  }
`;

export default DropzoneWrapper;
